<template>
  <div class="auth-wrapper auth-v1 px-2">
    <AnimatedAiBackground />
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo d-block">
          <div
            style="width: 300px"
            class="d-flex align-items-center justify-content-center mb-1 m-auto"
          >
            <img style="width: 100%" src="/sofIAweb.webp" alt="SofIA" />
          </div>
          <p
            v-if="!passVerification"
            style="color: #5e5873"
            class="brand-text ml-1 text-center mt-2"
          >
            {{ $t("generateCode_messaje") }}
          </p>
          <p
            v-else
            style="color: #5e5873"
            class="brand-text ml-1 text-center mt-2"
          >
            {{ $t("codeVerification_messaje") }}
          </p>
        </b-link>
        <!-- CODE GENERATE -->
        <validation-observer
          v-if="!passVerification"
          ref="generateForm"
          #default="{ invalid }"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="sendEmailFunction"
          >
            <b-form-group label-for="email" :label="$t('email')">
              <validation-provider
                #default="{ errors }"
                :name="$t('email')"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="login-email"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('email')"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div
              class="mt-2"
              style="display: flex; justify-content: end; align-items: center"
            >
              <b-button @click="back()">
                {{ $t("cancel") }}
              </b-button>
              <b-button
                class="ml-1"
                variant="primary"
                type="submit"
                :disabled="invalid"
              >
                {{ $t("search_email") }}
              </b-button>
            </div>
          </b-form>
        </validation-observer>
        <!-- CODE VALIDATION -->
        <validation-observer
          v-else
          ref="verificationForm"
          #default="{ invalid }"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="verificationCodeFuntion"
          >
            <b-form-group label-for="code" :label="$t('code_verification')">
              <validation-provider
                #default="{ errors }"
                :name="$t('verification')"
                rules="required"
              >
                <b-form-input
                  id="code_verification"
                  v-model="verificationCode"
                  name="code_verification"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('code_verification')"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div
              class="mt-2"
              style="display: flex; justify-content: end; align-items: center"
            >
              <b-button @click="back()">
                {{ $t("cancel") }}
              </b-button>
              <b-button
                class="ml-1"
                variant="primary"
                type="submit"
                :disabled="invalid"
              >
                {{ $t("verification") }}
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { GenerateCode, userByEmail, ValidateCode } from "@core/api/request";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BCol,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { showLoading, stopLoading } from "@core/utils/utils";
import AnimatedAiBackground from "../../landing/AnimatedAiBackground.vue";

export default {
  components: {
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    VuexyLogo,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BCol,
    AnimatedAiBackground,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: "",
      password: "",
      status: "",
      required,
      email,
      passVerification: false,
      verificationCode: "",
      guidUserToChange: "",
      updatePassWord: false,
    };
  },
  created() {
    localize("es");
  },
  methods: {
    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
      });
    },

    back() {
      this.$router.push({
        name: "auth-login",
      });
      this.userEmail = "";
    },

    sendEmailFunction() {
      this.$refs.generateForm.validate().then((success) => {
        if (success) {
          showLoading();
          const data = {
            email: this.userEmail,
          };
          GenerateCode(data)
            .then((response) => {
              stopLoading();
              if (response.data.err) {
                stopLoading();
                this.$refs.generateForm.setErrors(response.data.message);
                this.alertToast(
                  "danger",
                  "Alerta error",
                  response.data.message,
                );
              } else {
                this.passVerification = true;
                const data = {
                  email: this.userEmail,
                };
                userByEmail(data).then((resp) => {
                  console.log("RESPUESTA BUSQUEDA DE USUARIO", resp.data);
                  this.guidUserToChange = resp.data.guid;
                  console.log("GUIS ALMACENADO", this.guidUserToChange);
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.$refs.generateForm.setErrors(response.data.message);
              this.alertToast(
                "danger",
                "Alerta error",
                erroresponse.data.messager,
              );
            });
        }
      });
    },

    verificationCodeFuntion() {
      this.$refs.verificationForm.validate().then((success) => {
        if (success) {
          console.log(this.guidUserToChange);
          showLoading();
          const data = {
            guidUser: this.guidUserToChange,
            code: this.verificationCode,
          };
          ValidateCode(data)
            .then((resp) => {
              stopLoading();
              if (resp.data.err) {
                stopLoading();
                this.$refs.generateForm.setErrors(resp.data.message);
                this.alertToast("danger", "Alerta error", resp.data.message);
              } else {
                this.updatePasswordFunction();
              }
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.$refs.generateForm.setErrors(response.data.message);
              this.alertToast(
                "danger",
                "Alerta error",
                erroresponse.data.messager,
              );
            });
        }
      });
    },

    updatePasswordFunction() {
      this.$router.push({
        name: "update-password",
        params: {
          guid: this.guidUserToChange,
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
